import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DynamicTabModel } from '../interface/dynamic-tab-model';
import { MessageService } from '../../shared/services/message.service';
import { AuthorizationPipe } from '../../common/pipes/authorization.pipe';
import { DataShareService } from '../../shared/services/data.service';
import { DeleteModal } from '../models/delete-modal';
import { CommonMessage } from '../common/common-messages';
import { Modal } from 'ngx-modal';
import { AccountNotification } from '../interface/accountNotification';
import { TabsetComponent } from 'ngx-bootstrap';
import { TabConstants } from '../constants/tab.constants';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { CacheService } from '../../shared/services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';


@Component({
    selector: 'app-dynamic-tabs',
    templateUrl: '../templates/template1/views/dynamic-tabs.component.html',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: [
        //  "../templates/template1/themes/default/css/search.less"
    ],
    providers: [AuthorizationPipe]
})

export class DynamicTabsComponent implements OnInit, AfterViewInit {

    tabModel: DynamicTabModel;
    id: any;
    tabTitle: string;
    orderNumber?: string;
    webOrderNumber?: string;
    country?: string;
    componentName: any;
    orderType?: string;
    tabs: any[] = new Array<DynamicTabModel>();
    existedValues: DynamicTabModel[] = new Array<DynamicTabModel>();
    justifyingTabs = false;
    isNewOrder: number;
    memberType: string;
    deleteModal: DeleteModal;
    count = 0;
    activeTab = 1;
    @ViewChild('accountNotification') accountNotificationPopup: Modal;
    @ViewChild('dashboardTabs') dashboardTabs: TabsetComponent;
    notification: AccountNotification;
    memberTypeEnum = MemberTypeEnum;
    constructor(private messageService: MessageService, private _dataShareService: DataShareService,private cacheService:CacheService) { }

    ngOnInit(): void {
        this.tabModel = new DynamicTabModel();
        this.subscribeToNotifications();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
    }

    /**
     * @description To display recently viewed items.
     * @date 2019-06-26
     * @param {*} $event
     * @memberof DynamicTabsComponent
     */
    onSelect(): void {
        this.activeTab = 1;
        this.messageService.setRecentlyViewedInfo();
    }

    /**
     * To display notification immediately
     */
    subscribeToNotifications() {
        this.messageService.getAccountNotification().subscribe((notification: AccountNotification) => {
            if (notification) {
                const tab: DynamicTabModel = this.tabs.find(item => item.active === true);
                const index = tab ? this.tabs.map(el => el.id).indexOf(tab.id) : -1;
                if (index >= 0) {
                    if (notification.enable && (this.tabs[index].id === notification.id)) {
                        this.tabs[index].notification = notification;
                        this.notification = notification;
                        this.accountNotificationPopup.open();
                    }
                }
            }
        });
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof DynamicTabsComponent
     */
    subscribeTabContent() {
        this.messageService.getCustomerServiceTabContent().subscribe((data: any) => {
            if (data) {
                this.id = data.id;
                this.tabTitle = data.tabName;
                this.componentName = data.componentName;
                this.orderNumber = data.orderNumber;
                this.webOrderNumber = data.webOrderNumber;
                this.country = data.country;
                this.isNewOrder = data.isNewOrder;
                this.memberType = data.memberType;
                this.orderType = data.orderType;
                this.addNewTab();
                this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
            }
        });
    }

    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
  */
    subscribeClosedTabs() {
        this.messageService.getCloseTabsEvent().subscribe((data: any) => {
            if (data) {
                this.closeAllOpenedTabs();
            }
        });
    }

    /**
    * on clicking of "No" this method will be called.
    */
    doNotRemoveFormData() {
        // data should not be removed...
    }


    /**
     * adds new tab or activates existed tab
     */
    addNewTab(): void {
        this.count++;
        this.tabModel = new DynamicTabModel();
        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.activeTab = this.tabs.length + 2;
        this.tabModel.componentName = this.componentName;
        this.tabModel.orderNumber = this.orderNumber;
        this.tabModel.webOrderNumber = this.webOrderNumber;
        this.tabModel.country = this.country;
        this.tabModel.isNewOrder = this.isNewOrder;
        this.tabModel.memberType = this.memberType;
        this.tabModel.orderType = this.orderType;
        this.existedValues = new Array<DynamicTabModel>();
        this.activeTab = this.tabModel.activeTab;
        const index = this.tabs.map(tab => tab.id).indexOf(this.id);
            if (index < 0) {
                this.tabs.push(this.tabModel);
                setTimeout(() => {
                   this.getFocusNext();
                }, 100);
            } else {
                const selectedId = this.id;
                const newOrderNumber = this.orderNumber;
                const newWebOrderNumber = this.webOrderNumber;
                const tempCountry = this.country;
                const isNewOrder = this.isNewOrder;
                const component = this;
                this.tabs.forEach(function (x: DynamicTabModel) {
                    if (x.id !== selectedId) {
                        x.active = false;
                    } else {
                        x.active = true;
                        component.activeTab = x.activeTab;
                        x.orderNumber = newOrderNumber;
                        x.webOrderNumber = newWebOrderNumber;
                        x.country = tempCountry;
                        x.isNewOrder = isNewOrder;
                        if (x.notification) {
                            component.notification = x.notification;
                            if (component.notification.enable) {
                                component.accountNotificationPopup.open();
                            }
                        }
                    }
                });
            }

    }

    /**
     * triggers when tab is selected
     */
    tabSelected(tabz) {
        if (tabz) {
            if (!tabz.active) {
                tabz.active = true;
                this.activeTab = tabz.activeTab;
                if (tabz.notification) {
                    this.notification = tabz.notification;
                    if (this.notification.enable) {
                    }
                }
            }
        }
    }

    /**
     * onClick()
     * @param event
     */
    onClick(event): void {
        if (event && event.target && (event.target.getElementsByClassName('fa-angle-left').length)
        || event.target.classList.contains('fa-angle-left')) {
            this.focusPreviousTab(event);
        } else if (event && event.target && (event.target.getElementsByClassName('fa-angle-right').length)
        || event.target.classList.contains('fa-angle-right')) {
            this.focusNextTab(event);
        }

         event.stopImmediatePropagation();

    }

    /**
     * focusNextTab()
     */
    focusNextTab(event): void {
        if (this.tabs && this.tabs.length) {
            const tab = this.tabs.find(item => item.activeTab === this.activeTab);
           this.activeTab = tab ? tab.activeTab : 2;
                setTimeout(() => {
                this.activeTab = tab ? tab.activeTab : 2;
                this.getFocusNext();
            }, 50);
            const element = document.querySelector('.nav-tabs.cs-primary-tabs.cs-member-tabs.dashboard-member__tabs>ul.nav-tabs');
            if (element) {
                element.scrollLeft += 190;
            }
        } else {
            setTimeout(() => {
                 this.activeTab = 1;
                 this.onSelect();
            }, 50);
        }

    }
    getFocusNext():void{
    const element:any = document.querySelector('.nav-tabs.cs-primary-tabs.cs-member-tabs.dashboard-member__tabs>ul.nav-tabs');
       if(element && element.offsetWidth){
          element.scrollLeft =element.offsetWidth;
       }
    }
    /**
     * focusPreviousTab()
     * @param event
     */
    focusPreviousTab(event): void {
        if (this.tabs && this.tabs.length) {
            const tab = this.tabs.find(item => item.activeTab === this.activeTab);

             this.activeTab = tab ? tab.activeTab : 2;
            setTimeout(() => {
             this.activeTab = tab ? tab.activeTab : 2;
            }, 50);
            const element = document.querySelector('.nav-tabs.cs-primary-tabs.cs-member-tabs.dashboard-member__tabs>ul.nav-tabs');
            if (element) {
                const scrollRight = element.scrollLeft - 190;
                if (scrollRight) {
                    element.scrollLeft -= 190;
                } else {
                    element.scrollLeft = 0;
                }
            }
        } else {
            setTimeout(() => {
                this.activeTab = 1;
            }, 50);
        }
    }

    /**
     * ngAfterViewInit
     */
    ngAfterViewInit(): void {
        const leftArrowElem = document.querySelectorAll
        ('.nav-tabs.cs-primary-tabs.cs-member-primary-tabs.find-account__tabs>ul.nav-tabs li')[1];
        leftArrowElem.addEventListener('click', this.onClick.bind(this));
        const rightArrowElem = document.querySelectorAll
        ('.nav-tabs.cs-primary-tabs.cs-member-primary-tabs.find-account__tabs>ul.nav-tabs li')[2];
        rightArrowElem.addEventListener('click', this.onClick.bind(this));
    }

    /**
     * close Account Notification Popup
     */
    closePopUpforAccountNotificationChange() {
        this.accountNotificationPopup.close();
    }

    /**
     * removes tab at specific index
     * @param tab
     */
    removeTabHandler(tab: any): void {
        if (this.tabs) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.clearLocalStorageForProfileImageCDNURLforFboId(tab.id);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
            const tabIndex = this.dashboardTabs.tabs.findIndex(item => item.id === TabConstants.CUSTOMER_SEARCH);
            if(this.activeTab===tab.activeTab){
            this.activeTab = 1;
            }
        }
    }

    /**
     * Close all opened tabs
     */
    closeAllOpenedTabs() {
        this.tabs = []; // new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
    }

    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    displayAlertBoxOnReachingMaxTabs() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    }

    /**
     * To remove particular tab for update FBOID of an order.
     * @param $event
     */

    closeParticularTabForDistributorId($event):void{
        let distributorIdforCloseParticularTab:string  = $event ;
        if(this.tabs && distributorIdforCloseParticularTab){
            const tab = this.tabs.find(tab => tab.id === distributorIdforCloseParticularTab);
            if(tab) this.removeTabHandler(tab);
        }
    }

    clearLocalStorageForProfileImageCDNURLforFboId(fboId:string):void{
        let data:any =new Map(JSON.parse(this.cacheService.get(CacheKey.CDNurlForProfileImage)));
        if(data!=null && data.has(fboId)){
          data.delete(fboId);
          this.cacheService.set(CacheKey.CDNurlForProfileImage,JSON.stringify(Array.from(data.entries())));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/dynamic-tabs.component.ts